import isEmpty from 'lodash/isEmpty';
import {
  BasePetProfile,
  CatProfile,
  DogProfile,
  isCatProfile,
  isDogProfile,
  PetProfile,
} from 'types/pet-profile';

export const isValueEmpty = (value: unknown): boolean => {
  if (typeof value === 'number') return !Number.isFinite(value);
  return isEmpty(value);
};

/**
 * Checks if it empty pet profile
 * See {@link https://petsdeli.atlassian.net/wiki/spaces/PT/pages/2581954577/Is+Pet+Profile+Empty+definition | Is Pet Profile Empty definition}
 */
export const isEmptyProfile = (petProfile: PetProfile): boolean => {
  const basePropertiesToCheck: Array<keyof BasePetProfile> = [
    'selectedAge',
    'selectedNeeds',
    'selectedAllergies',
    'selectedWeight',
    'name',
  ];

  const checkDogProperties: Array<keyof DogProfile> = [...basePropertiesToCheck, 'selectedBreed'];

  const checkCatProperties: Array<keyof CatProfile> = [
    ...basePropertiesToCheck,
    // 'selectedTastePreferences', TODO: this is under discussion
  ];

  if (isDogProfile(petProfile)) {
    for (const property of checkDogProperties) {
      const value = petProfile[property];
      if (!isValueEmpty(value)) {
        return false;
      }
    }
  }

  if (isCatProfile(petProfile)) {
    for (const property of checkCatProperties) {
      const value = petProfile[property];
      if (!isValueEmpty(value)) {
        return false;
      }
    }
  }

  return true;
};
